import React from 'react';
import { Link } from 'react-router-dom';
import { statusLabel } from '../utils/lmsSelectors';

export function PageHeader({ title, eyebrow, description, action }) {
  return (
    <div className="page-header">
      <div>
        {eyebrow && <p className="eyebrow">{eyebrow}</p>}
        <h1>{title}</h1>
        {description && <p className="muted max-width">{description}</p>}
      </div>
      {action && <div className="page-action">{action}</div>}
    </div>
  );
}

export function MetricCard({ label, value, helper, icon }) {
  return (
    <div className="metric-card">
      <div className="metric-icon">{icon}</div>
      <span>{label}</span>
      <strong>{value}</strong>
      {helper && <small>{helper}</small>}
    </div>
  );
}

export function StatusBadge({ status }) {
  const normalized = String(status || 'unknown').toLowerCase();
  return <span className={`status-badge status-${normalized.replace(/_/g, '-')}`}>{statusLabel(status)}</span>;
}

export function RoleBadge({ role }) {
  return <span className={`role-badge role-${role}`}>{statusLabel(role)}</span>;
}

export function ProgressBar({ value }) {
  const safe = Math.max(0, Math.min(100, Number(value || 0)));
  return (
    <div className="progress-wrap" aria-label={`${safe}% complete`}>
      <div className="progress-fill" style={{ width: `${safe}%` }} />
      <span>{safe}%</span>
    </div>
  );
}

export function EmptyState({ title, message, action }) {
  return (
    <div className="empty-state">
      <h3>{title}</h3>
      <p>{message}</p>
      {action}
    </div>
  );
}

export function DataTable({ columns, rows, emptyMessage = 'No records found.' }) {
  if (!rows.length) return <EmptyState title="No data" message={emptyMessage} />;
  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>{columns.map((column) => <th key={column.key}>{column.label}</th>)}</tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={row.id || row.email || `${row.rowNumber || 'row'}-${rowIndex}`}>
              {columns.map((column) => <td key={column.key}>{column.render ? column.render(row) : row[column.key]}</td>)}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function Card({ children, className = '' }) {
  return <section className={`card ${className}`}>{children}</section>;
}

export function ButtonLink({ to, children, variant = 'primary' }) {
  return <Link className={`button button-${variant}`} to={to}>{children}</Link>;
}

export function FormRow({ label, children }) {
  return (
    <label className="form-row">
      <span>{label}</span>
      {children}
    </label>
  );
}

export function MiniBar({ label, value }) {
  return (
    <div className="mini-bar-row">
      <span>{label}</span>
      <div className="mini-bar-track"><div className="mini-bar-fill" style={{ width: `${Math.min(100, value)}%` }} /></div>
      <strong>{value}%</strong>
    </div>
  );
}
